// src/com/mobile_menu_auth/MobileMenuAuthGql.js
import { gql } from "@apollo/client";
import { MobileMenuId } from "../../value/AppConst";

/* ************************************************
 * MOBILE_MENU_AUTH Apollo Graphql
 * 모바일용 메뉴별 권한 할당
 * Project: NewTOP for cloud
 * 2025-04-29 16:40:55 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const MOBILE_MENU_AUTH_LIST_PART = gql`
fragment MobileMenuAuthListPart on MobileMenuAuth {
    authClassId
    menuId
    menuName
    menuOrder
}
`;


export const LIST_MOBILE_MENU_AUTH = gql`
${MOBILE_MENU_AUTH_LIST_PART}
query ListMobileMenuAuth($authClassId:String) {
    mobileMenuAuthList(authClassId:$authClassId) {
        ...MobileMenuAuthListPart
    }
}
`;

export function makeMobileMenuList(records) {
    const menuList = [];
    records.forEach((menu) => {
        menuList.push({
            menuId: menu.menuId,
            menuName: menu.menuName,
            menuOrder: menu.menuOrder,
        });
    });
    /* menuList.push({
        menuId: MobileMenuId.LogOut,
        menuName: '로그아웃',
        menuOrder: 9999,
    }); */
    return menuList.sort((a, b) => {
        return a.menuOrder - b.menuOrder;
    });
}